import { render, staticRenderFns } from "./InputErrors.vue?vue&type=template&id=6f22f060&scoped=true&"
import script from "./InputErrors.vue?vue&type=script&setup=true&lang=ts&"
export * from "./InputErrors.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./InputErrors.vue?vue&type=style&index=0&id=6f22f060&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f22f060",
  null
  
)

export default component.exports